import {
  ParentingTestType,
  ParticipantRelationship,
} from '@app/modules/service-data/types/paternity.types';
import {
  Ethnicity,
  Gender,
  PriorScreeningTestType,
} from '@app/modules/service-data/types/service-data.types';
import { PaymentType } from '@core/core.types';
import { Util } from '@core/utils/core.util';
import moment from 'moment';

export const prefillData = {
  id: Util.CreateGuid(),
  notes: '',
  paymentInformation: {
    paymentType: PaymentType.Customer1,
    notes: 'This is a test service data!',
  },
  patientInformation: {
    firstName: 'Mojca',
    lastName: 'Pokrajculja',
    dateOfBirth: moment().add(-25, 'y'),
    email: 'mojca.pokrajculja@geneplanet.com',
    phoneNumber: '041111111',
  },
  serviceInformation: {
    nipt: {
      currentPregnancyInformation: {
        priorScreeningTest: {
          priorScreeningTestType: PriorScreeningTestType.NoTestTaken,
          firstTRisks: {
            t21Risk: null,
            t18Risk: null,
            t13Risk: null,
          },
          secondTRisks: {
            t21Risk: null,
            t18Risk: null,
            t13Risk: null,
          },
        },
      },
      provideGenderInformation: false,
      incidentalFindings: false,
    },
    mono: {
      patientHistory: {
        monogenicDisorderCarrier: {
          isCarrier: false,
        },
      },
      monogenicIncidentalFindings: false,
    },
    rhd: {
      patientHistory: {
        rhdStatus: {
          status: false,
        },
      },
    },
    carrier: {
      patientHistory: {
        cysticFibrosisHistory: {
          hasHistory: false,
        },
      },
    },
    cancerScreen: {
      patientHistory: {
        diseaseHistory: {
          hasHistory: false,
        },
        familyCancerHistory: {
          hasHistory: false,
        },
        knownFamilyMutations: {
          hasHistory: false,
        },
      },
    },
    galleri: {
      currentPregnancyInformation: {
        isPregnant: false,
      },
      patientHistory: {
        currentlyDiagnosedWithCancer: false,
        cancerSuspicion: {
          isSuspicious: false,
          suspicionDescription: null,
        },
        cancerSurvivor: {
          isSurvivor: false,
          moreThanThreeYearsAgo: null,
        },
        solidOrganTransplant: {
          hasReceived: false,
        },
      },
    },
    nippt: {
      allegedFather: {
        firstName: 'Janez',
        lastName: 'Pokrajculja',
        documentNumber: 'JP20211102',
        dateOfBirth: moment().add(-30, 'y'),
        email: 'janez.pokrajculja@geneplanet.com',
        phoneNumber: '041222222',
        ethnicitySelect: Ethnicity.Caucasian,
      },
      patientHistory: {
        anotherPregnancy: {
          wasPregnant: false,
        },
        anyReceivedStemCell: false,
        anyReceivedBloodTransfusion: false,
      },
    },
    paternity: {
      parentingTestType: ParentingTestType.Paternity,
      relationship: ParticipantRelationship.Mother,
      // Only patches participants that exist for the selected bundle
      additionalParticipants: [
        {
          firstName: 'Janez',
          lastName: 'Pokrajculja',
          dateOfBirth: moment().add(-30, 'y'),
          email: 'janez.pokrajculja@geneplanet.com',
          gender: Gender.Male,
          relationship: ParticipantRelationship.Father,
        },
        {
          firstName: 'Miha',
          lastName: 'Pokrajculja',
          dateOfBirth: moment().add(-2, 'y'),
          email: 'mojca.pokrajculja@geneplanet.com',
          gender: Gender.Male,
          relationship: ParticipantRelationship.Child,
        },
      ],
    },
    venisafe: {
      patientHistory: {
        cardiovascularConditions: {
          hasHistory: false,
        },
        cardiovascularConditionsInFamily: {
          hasHistory: false,
        },
      },
    },
    shared: {
      patientGender: Gender.Female,
      patientInformation: {
        documentNumber: 'MP20211102',
        height: 170,
        weight: 60,
        ethnicitySelect: Ethnicity.Caucasian,
        address: {
          street: 'Slovenska cesta 1',
          city: 'Ljubljana',
          zip: '1000',
          country: 'Slovenia',
        },
      },
      patientHistory: {
        numberOfPregnancies: 1,
        numberOfBirths: 0,
        cancerHistory: {
          hasHistory: false,
        },
        albuminTherapy: {
          hasReceived: false,
        },
        cellularImmunotherapy: {
          hasReceived: false,
        },
        stemCellTherapy: {
          hasReceived: false,
        },
        transplantSurgery: {
          hasReceived: false,
        },
        bloodTransfusion: {
          hasReceived: false,
        },
        familyDiseaseHistory: {
          hasHistory: false,
        },
        pregnancyDiseaseHistory: {
          hasHistory: false,
        },
        chromosomalAbnormalityCarrier: {
          isCarrier: false,
        },
        boneMarrowTransplant: {
          hasReceived: false,
        },
      },
      currentPregnancyInformation: {
        expectedConfinementDate: moment().add(25, 'w'),
        isGestationAgeAutomaticallyCalculated: true,
        inVitro: {
          isInVitroFertilized: false,
        },
        vanishingTwinSyndrome: {
          isDetected: false,
        },
        heparinTherapy: {
          hasReceived: false,
        },
        ultrasoundDate: moment().subtract(1, 'w'),
      },
      comments: '',
    },
  },
};
